import { SaveBookmark as ModeSaveBookmark } from '@stitch-fix/mode-react/ProductCard';
import { ApolloCache, NormalizedCacheObject } from '@apollo/client';
import { useDestroySavedItemMutation } from '../../../../../utils/hooks/destroySavedItem';
import { useCreateSavedItemMutation } from '../../../../../utils/hooks/createSavedItem';
import { COPY } from '../../../../../utils/copy';
import { useToast } from '../../../../../utils/contexts/toast-provider';
import { ShopProductVariantSavedFragmentDoc } from '../../../../../utils/hooks/getSearchResults';
import { SavedItemToastLink } from '../../../../../components/ResultsLayout/BookmarkButton/SavedItemToastLink';
const {
  savedItemSuccessMessage,
  unsavedItemSuccessMessage,
  errorToastMessage
} = COPY;
interface BookmarkButtonProps {
  id: string;
  isSaved: boolean;
}
const updateCacheForShopProductVariant = (cache: ApolloCache<NormalizedCacheObject>, shopProductVariantId: string, saved: boolean) => {
  cache.writeFragment({
    id: `ShopProductVariant:${shopProductVariantId}`,
    fragment: ShopProductVariantSavedFragmentDoc,
    data: {
      saved
    }
  });
};

/**
 * This component handles state and toast message for the bookmark button
 */
const BookmarkButton = ({
  id,
  isSaved
}: BookmarkButtonProps) => {
  const {
    addToast
  } = useToast();
  const [createSavedItem, {
    loading: isCreateLoading
  }] = useCreateSavedItemMutation({
    variables: {
      id
    },
    onCompleted: () => addToast({
      endContent: <SavedItemToastLink />,
      message: savedItemSuccessMessage,
      status: 'success'
    }),
    onError: () => addToast({
      message: errorToastMessage
    }),
    update: (cache, {
      data
    }) => {
      if (!data?.savedItemCreate?.result) return;
      updateCacheForShopProductVariant(cache, id, true);
    }
  });
  const [destroySavedItem, {
    loading: isDestroyLoading
  }] = useDestroySavedItemMutation({
    variables: {
      id
    },
    onCompleted: () => addToast({
      message: unsavedItemSuccessMessage,
      status: 'success'
    }),
    onError: () => addToast({
      message: errorToastMessage
    }),
    update: (cache, {
      data
    }) => {
      if (!data?.savedItemDestroy?.result) return;
      updateCacheForShopProductVariant(cache, id, false);
    }
  });
  return <ModeSaveBookmark size="small" isSaved={isSaved} onClick={() => {
    if (isSaved) {
      destroySavedItem();
    } else {
      createSavedItem();
    }
  }} disabled={isCreateLoading || isDestroyLoading} />;
};
export default BookmarkButton;